import React from 'react'
import _ from 'lodash'

export default class CheckboxGroup extends React.Component {
  
  eventHandler = e => {
    let values = this.props.values
    let { value, checked } = e.target
    value = _.isNaN(Number(value)) ? value : Number(value)
    let isValue = _.includes(values, value)

    if (checked && !isValue) {
      values = _.concat(values, value)
    } else if (!checked && isValue) {
      values = _.pull(values, value)
    }
    return values
  }

  handleChecked = value => {
    return _.includes(this.props.values, value)
  }

  onCheckoutGroupChange = e => {
    const values = this.eventHandler(e)
    if (this.props.onChange) this.props.onChange(values)
  }

  onCheckoutGroupBlur = e => {
    const values = this.eventHandler(e)
    if (this.props.onBlur) this.props.onBlur(values)
  }

  render() {
    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, {
        onChange: this.onCheckoutGroupChange,
        onBlur: this.onCheckoutGroupBlur,
        checked: this.handleChecked(child.props.value),
      }),
    )

    return <div>{childrenWithProps}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/views/widgets/CheckboxGroup.js